import { render } from "./JuntaPicker.vue?vue&type=template&id=5fd04464&scoped=true"
import script from "./JuntaPicker.vue?vue&type=script&lang=ts"
export * from "./JuntaPicker.vue?vue&type=script&lang=ts"

import "./JuntaPicker.vue?vue&type=style&index=0&id=5fd04464&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fd04464"

export default script